import { default as videojs } from 'video.js';
import { QualityLevelList } from 'videojs-contrib-quality-levels';
import { QualitySelectionRepresentation } from '../../../plugin';
import { PlanetVideoJs, QualityCache, QualityMenuOptions } from '../models';

const MenuItem: typeof videojs.MenuItem = videojs.getComponent('MenuItem');

export class QualityMenuItem extends MenuItem {

    player_: PlanetVideoJs;

    private readonly isAuto: boolean = false;
    private readonly representations: QualitySelectionRepresentation[] = [];
    private readonly representation: QualitySelectionRepresentation = null;
    private readonly representationIndex: number = 0;

    constructor(player: videojs.Player, options: QualityMenuOptions) {
        super(player, options);

        const cache: QualityCache = this.player_.getCache();

        const qualityLevels: QualityLevelList = this.player_.qualityLevels();

        this.isAuto = options.isAuto;
        this.representation = options.representation;
        this.representations = options.representations;
        this.representationIndex = options.representationIndex;

        cache.qualityAutoSelectEnabled = true;

        qualityLevels.on('change', this.onQualityChange.bind(this));
        this.player_.on('qualityAutoSelectDisabled', () => {
            this.selected(this.representationIndex === qualityLevels.selectedIndex);
            qualityLevels.on('change', this.onQualityChange.bind(this));
        });
        this.player_.on('qualityAutoSelectEnabled', () => {
            this.selected(this.isAuto);
            this.representations.forEach(r => r.enabled(true));
            qualityLevels.off('change', this.onQualityChange.bind(this));
        });
    }

    onQualityChange(event: { selectedIndex?: number }): void {
        const cache: QualityCache = this.player_.getCache();

        if (cache.qualityAutoSelectEnabled) {
            return;
        }

        let isSelected: boolean = event.selectedIndex === this.representationIndex;
        this.selected(isSelected);
    }

    handleClick(event: Event): void {
        const cache: QualityCache = this.player_.getCache();
        const representation: QualitySelectionRepresentation = this.representation;
        const representations: QualitySelectionRepresentation[] = this.representations;

        if (this.isAuto) {
            if (!(cache.qualityAutoSelectEnabled)) {
                cache.qualityAutoSelectEnabled = true;
                this.player_.trigger('qualityAutoSelectEnabled');
            }
        } else {
            if (cache.qualityAutoSelectEnabled === true) {
                cache.qualityAutoSelectEnabled = false;
                this.player_.trigger('qualityAutoSelectDisabled');
            }
            this.selected(true);
            representations.forEach((item: QualitySelectionRepresentation) => {
                if (item.id === representation.id) {
                    item.enabled(true);
                } else {
                    item.enabled(false);
                }
            });
        }
    }
}
